import { P11Template } from '../../../common/enums/P11Template';

export class ReportKeyDetail {
  constructor(
    private readonly id: number,
    private readonly shortDescription: string,
    private readonly operationSummary: string | null,
    private readonly valueJson: object | null,
    private readonly metadata: object | null,
    private readonly organizationKeyId: number | null,
    private readonly source: string | null,
    private readonly hasPrivateKey: boolean | null,
    private readonly pkcs11Attributes: P11Template[] | null
  ) {}

  getShortDescription() {
    return this.shortDescription;
  }

  getOperationSummary() {
    return this.operationSummary;
  }

  getValueJson() {
    return this.valueJson;
  }

  getMetadata() {
    return this.metadata;
  }

  getOrganizationKeyId() {
    return this.organizationKeyId;
  }

  getSource() {
    return this.source;
  }

  getHasPrivateKey() {
    return this.hasPrivateKey;
  }

  getPkcs11Attributes() {
    return this.pkcs11Attributes;
  }
}
